<template>
  <VDropdown
    theme="tooltip-no-arrow"
    :triggers="['click']"
    placement="bottom-start"
    auto-hide
    :container="popoverContainer || false"
  >
    <button class="sprd-btn-light">
      <label role="button" aria-haspopup="true">
        {{ $t(props.heading) }}
        <div v-if="count" class="count">
          {{ count }}
        </div>
        <Icon icon="down" />
      </label>
    </button>

    <template #popper>
      <div @click.stop>
        <slot></slot>
      </div>
    </template>
  </VDropdown>
</template>

<script setup lang="ts">
const props = defineProps<{
  heading: string;
  count: number;
  popoverContainer?: boolean | string;
}>();
</script>

<style scoped lang="scss">
@import 'src/scss/styleguide/colors';

.sprd-btn-light {
  padding-left: 12px;
  padding-right: 12px;
}

label {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.count {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $pa-color-main;
  color: $white;
  font-size: 10px;
}

.icon {
  margin-left: 4px;
}
</style>
